<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" :max-width="600" persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-text.pa-6
      div.text-xl.font-medium.neutral700--text Finish counting?
      div.text-md.neutral700--text.mt-4 This action will be done immediately and can’t be undone. Click “Confirm” to proceed
    v-divider
    v-card-actions.pb-4.pt-3.px-6
      y-button.mr-4(:label="$t('cancel')" underline color="neutral700" size="md" button-class="px-0" @click="closeDialog")
      v-spacer
      y-button(label="Confirm" text-color="neutral100" color="neutral700" size="md" dark :loading="isLoading" @click="saveData")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      isLoading: false,
    }
  },
  computed: {
    ...mapGetters({ company: 'getCompany' }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  mounted () {},
  methods: {
    ...mapActions(['showMessage']),
    saveData () {
      this.$emit('finish')
      this.closeDialog()
    },
    closeDialog () {
      this.showDialog = false
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
  .date-field .v-input__append-inner {
    margin-top: 12px !important;
  }
  .left-count-btn {
    border-radius: 10px 0 0 10px;
    border-color: var(--v-neutral400);
    border-right: 0px;
  }
  .right-count-btn {
    border-radius: 0 10px 10px 0;
    border-color: var(--v-neutral400);
    border-left: 0px;
  }
}
</style>